import { render, staticRenderFns } from "./PracticeView.vue?vue&type=template&id=337bde8f&scoped=true&"
import script from "./PracticeView.vue?vue&type=script&lang=ts&"
export * from "./PracticeView.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeView.vue?vue&type=style&index=0&id=337bde8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337bde8f",
  null
  
)

export default component.exports